import React from "react";
import {Link} from "react-router-dom";
import {FORGOT_PASSWORD} from "../../../constants/routes";

/**
 * A simple Forgot password link with a provided prompt
 */
export const ForgotPasswordLink = () => {
    return (
        <div>
            <Link to={FORGOT_PASSWORD}>Forgot password?</Link>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/auth/forgotpassword/ForgotPasswordLink.jsx